import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isMomentPropType } from '../../lib/customPropTypes';
import moment from 'moment';
import Day from './Day';

export default class Week extends Component {

  static defaultProps = {
    utcOffset: moment.utc().utcOffset()
  };

  static propTypes = {
    className: PropTypes.string,
    day: PropTypes.object.isRequired,
    excluded: PropTypes.array,
    filtered: PropTypes.func,
    highlighted: PropTypes.func,
    included: PropTypes.array,
    maxDate: PropTypes.object,
    minDate: PropTypes.object,
    month: PropTypes.number,
    onDayClick: PropTypes.func,
    selected: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.instanceOf(Date),
      isMomentPropType,
    ]),
    utcOffset: PropTypes.number
  };

  constructor(props, context) {
    super(props, context);
    this.renderDays = this.renderDays.bind(this);
  }

  onDayClick (day) {
    if (this.props.onDayClick) {
      this.props.onDayClick(day);
    }
  }

  renderDays () {
    const startOfWeek = this.props.day.clone().startOf('week');
    const days = [];
    for (let i = 0; i < 7; i++) {
      const day = startOfWeek.clone().add(i, 'days');
      days.push(
        <Day
          key={i}
          day={day}
          month={this.props.month}
          onClick={this.onDayClick.bind(this, day)}
          minDate={this.props.minDate}
          maxDate={this.props.maxDate}
          excluded={this.props.excluded}
          included={this.props.included}
          highlighted={this.props.highlighted}
          filtered={this.props.filtered}
          selected={this.props.selected}
          utcOffset={this.props.utcOffset}/>
      );
    }
    return days;
  }

  render () {
    return (
      <tr className={this.props.className}>
        {this.renderDays()}
      </tr>
    );
  }

}
